import React from 'react'
import { getMessage } from '../../../util/IntlMessages'
import { Column } from 'primereact/column'

export const columnsAlternativeAvailableList = [
  <Column key="selection" selectionMode="multiple" headerStyle={{ width: '3em' }} style={{ maxWidth: '15px' }} />,
  <Column
    key="partnerName"
    field="partnerName"
    header={getMessage('customer')}
    filterField="partnerName"
    filter
    filterMatchMode="contains"
    filterPlaceholder={getMessage('search')}
    responsive={true}
  />,
  <Column
    key="documentNumber"
    field="documentNumber"
    header={getMessage('documentNumber')}
    filterField="documentNumber"
    filter
    filterMatchMode="contains"
    filterPlaceholder={getMessage('search')}
    responsive={true}
  />,
  <Column
    key="approvalStatus"
    field="approvalStatus"
    header={getMessage('approvalStatus')}
    filterField="approvalStatus"
    filter
    filterMatchMode="contains"
    filterPlaceholder={getMessage('search')}
    responsive={true}
  />
]
